import React, { Component, useState, useEffect } from "react"
import PropTypes from "prop-types"
import queryString from "query-string"
import SbEditable from "storyblok-react"
import Components from "../index"
import SbImageService from "../../helpers/SbImageService"
import { unified } from "unified"
import remarkParse from "remark-parse"
import remarkRehype from "remark-rehype"
import rehypeReact from "rehype-react"
import linkHandler from "../../helpers/storyblokLinkHandler"
import remarkReactComponents from "../../helpers/remarkReactComponents"
import Image from "../image"

export const HeroV2Modal = ({ blok }) => {
  const [contact, setContact] = useState({})
  useEffect(() => {
    if (typeof window !== "undefined") {
      const queryParams = queryString.parse(window.location.search)
      const contactId = queryParams.S
      let contact = {}
      if (contactId) {
        fetch(
          `${process.env.GATSBY_SALESFORCE_API}/hulthousing/services/apexrest/GetContactInfo`,
          {
            method: "post",
            body: JSON.stringify({ contactID: contactId }),
          }
        )
          .then((resp) => {
            return resp.json()
          })
          .then((data) => {
            setContact(JSON.parse(data))
          })
      } else {
        setContact({})
      }
    }
  }, [])
  return (
    <SbEditable content={blok}>
      <div className="hero-v2-modal">
        <div className="hero-v2-modal__card">
          <div className="hero-v2-modal__inner">
            {blok.logo.filename && (
              <a
                title="Hult"
                href={linkHandler(blok.logoUrl)}
                className="hero-v2-modal__card-logo hero-v2-modal__card-logo--desktop"
              >
                <img alt="Hult" className="hero-v2-modal__card-logo-image hero-v2-modal__card-logo-image--desktop" src={blok.logo.filename} />
              </a>
            )}
            {blok.logoMobile.filename && (
              <a
                title="Hult"
                href={linkHandler(blok.logoUrl)}
                className="hero-v2-modal__card-logo hero-v2-modal__card-logo--mobile"
              >
                <img alt="Hult" className="hero-v2-modal__card-logo-image hero-v2-modal__card-logo-image--mobile" src={blok.logoMobile.filename} />
              </a>
            )}
            {blok.title && (
              <h1 className="hero-v2-modal__card-title heading--accent">{contact.FirstName ? contact.FirstName + ", " : ""}{blok.title}</h1>
            )}
            <div className="hero-v2-modal__card-desc-image">
              {blok.description && (
                <div className="hero-v2-modal__card-description">
                  {
                    unified()
                      .use(remarkParse)
                      .use(remarkRehype)
                      .use(rehypeReact, {
                        createElement: React.createElement,
                        components: remarkReactComponents,
                        Fragment: React.Fragment
                      })
                      .processSync(blok.description).result
                  }
                </div>
              )}
              {blok.brochureImage.filename && (
                <img alt="Hult" className="hero-v2-modal__card-image" src={blok.brochureImage.filename} />
              )}
            </div>
            <div className="hero-v2-modal__card-buttons">
              {blok.button && blok.button.map(
                (content) =>
                  React.createElement(Components(content.component),
                    {
                      key: content._uid,
                      blok: content,
                    }
                  )
              )}
            </div>
          </div>
        </div>
        <div className={`hero-v2-modal__image`} style={{ backgroundImage: `url("${SbImageService(blok.heroImage.filename)}")` }}>
          {blok.heroShape.filename && (
            <Image
              blok={{
                image: blok.heroShape.filename,
                alt: blok.heroShape.filename,
                title: blok.heroShape.filename,
              }}
              className="hero-v2-modal__image-shape"
            />
          )}
        </div>
      </div>
    </SbEditable>
  )
}

HeroV2Modal.propTypes = {
  blok: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
  }).isRequired,
}

export default HeroV2Modal
